var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 62",
    width: 30,
    height: 4,
    rx: 2,
    fill: "#5FCFB8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 63",
    y: 10,
    width: 30,
    height: 4,
    rx: 2,
    fill: "#5FCFB8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 64",
    y: 20,
    width: 30,
    height: 4,
    rx: 2,
    fill: "#5FCFB8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSignup);
export default __webpack_public_path__ + "static/media/menu-signup.2107840f19a47aef8d2ce02b8969ad43.svg";
export { ForwardRef as ReactComponent };